module.exports = __webpack_public_path__ + "media/images/sp/stores/tachikawa/tachikawa_concept_02-9297d98c6e4806e6ed610034244c9888.jpg";